module.exports = __webpack_public_path__ + "img/karina-kleewein.099cb517.jpg";